export const generateUrlWithSearchParams = (searchParams: string) => {
  return `${window.location.origin}${window.location.pathname}?${searchParams}`;
};

export const getBaseUrl = () => window.location.origin;
